export default __webpack_public_path__ + "static/orthoBG1-2192f0eeb62308c82cd296b60b4c1c43.png";